<div class="grid-container">
    @if (name) {
        <span class="label">user:</span>
        <span class="value">{{name}}</span>
    }
    <span class="label">email:</span>
    <span class="value">{{email}}</span>
</div>
